import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TokenService } from "@auth/services/token/token.service";
import { OAuthService } from "angular-oauth2-oidc";

export const authUserGuard: CanActivateFn = () => {
    const router = inject(Router);
    const oauthService = inject(OAuthService);
    const tokenService = inject(TokenService);

    const token = tokenService.getToken();
    const hasValidAccessToken = oauthService.hasValidAccessToken();
    const canAccessAcw = tokenService.hasPermissions(["acw"]);
    const isAcwAdmin = tokenService.hasPermissions(["acwadmin"]);

    if (hasValidAccessToken && token?.viewPhi && (canAccessAcw || isAcwAdmin)) {
        return true;
    }

    if (token !== null) {
        return router.createUrlTree(["/unauthorized"]);
    }

    oauthService.initCodeFlow();
    return false;
};
